import { Service } from '@ml/services/types/service';
import { Machine } from '@ml/machineries/types/machine';
import { Attachment } from '@ml/machineries/types/attachment';
import { Customer } from '@ml/customers/types/customer';
import { Location } from '@ml/locations/types';
import { TaskViewModeType } from '@ml/orders/types/enums';

export enum OrderStatus {
  REQUESTED = 'requested',
  REGISTERED = 'registered',
  IN_PROGRESS = 'inprogress',
  DONE = 'done',
  READY_ACCOUNTING = 'ready_accounting',
  INVOICE_ISSUED = 'invoice_issued',
  PAID = 'paid',
  CANCELLED = 'cancelled'
}

export class Order {
  id?: number;
  name: string;
  created?: string | Date;
  startDate?: string | Date;
  dueDate?: string | Date;
  time?: string;
  customer: number | Customer;
  status?: OrderStatus;
  taskViewMode?: string;
  locationViewMode?: string;
  commented?: boolean;

  description: string;
  locations: number[];
  numberOfLocations: number;

  /**
   * Used only when a customer creates an order
   */
  customerLocations?: Location[];
  readonly good?: boolean;
}

export class FlattenOrder extends Order {
  attachments: Attachment[];
  machines: Machine[];
  services: Service[];
}
